var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00358 0.119873C2.91525 0.119873 0.0934111 2.90547 0.0934111 6.02966C0.0934111 7.74931 0.0920758 14.5554 0.0907406 21.3209C0.656234 21.6766 3.37926 22.5502 4.4742 22.6275C6.87218 22.7971 8.35911 22.0042 8.58926 20.0059L8.57715 12.5836H13.8817V19.8363C13.6031 23.9904 9.95831 24.8366 4.41096 24.5569C2.97515 24.4844 1.02306 24.1143 0.0900729 23.8713C0.0887376 30.6425 0.0874023 36.706 0.0874023 36.706C0.0874023 36.706 7.01267 36.706 9.31899 36.706C11.8381 36.706 15.1171 34.3521 15.1171 30.7726C15.1171 24.7656 15.1171 0.119873 15.1171 0.119873C15.1171 0.119873 8.35911 0.119873 6.00358 0.119873Z",
    fill: "url(#paint0_linear_3928_11528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9405 0.119385C19.8523 0.119385 17.0303 2.90498 17.0303 6.02917C17.0303 7.11867 17.0299 10.2499 17.0291 14.1187C18.8822 12.6714 21.8688 11.9617 25.6695 12.2545C27.8319 12.4209 29.4319 12.7227 30.3038 12.981V15.5485C29.3426 15.069 27.4457 14.3546 25.8631 14.2406C22.2784 13.9822 20.397 15.6621 20.397 18.3773C20.397 20.821 21.8505 22.912 25.8471 22.6335C27.1653 22.5417 29.3592 21.7736 30.2929 21.3294L30.3038 23.8203C29.5004 24.0737 27.0007 24.618 24.648 24.6371C21.1062 24.666 18.6071 23.9138 17.0274 22.6932C17.0258 29.9226 17.0244 36.7055 17.0244 36.7055C17.0244 36.7055 23.9496 36.7055 26.2559 36.7055C28.775 36.7055 32.0541 34.3516 32.0541 30.7721C32.0541 24.7651 32.0541 0.119385 32.0541 0.119385C32.0541 0.119385 25.2961 0.119385 22.9405 0.119385Z",
    fill: "url(#paint1_linear_3928_11528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4591 19.1562C39.4479 19.1656 37.2429 19.146 36.8439 19.1555L36.8379 22.3882L40.453 22.4C41.1556 22.4 42.0395 21.7981 42.0395 20.7496C42.0396 19.8218 41.2767 19.1485 40.4591 19.1562Z",
    fill: "url(#paint2_linear_3928_11528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6005 15.9116C41.6005 14.984 40.9033 14.3582 40.1624 14.3754C39.1209 14.3997 37.2425 14.3497 36.8319 14.3861L36.8198 17.329L40.2351 17.3532C40.8032 17.3417 41.6005 16.8211 41.6005 15.9116Z",
    fill: "url(#paint3_linear_3928_11528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.799 0.119481C36.7107 0.119481 33.8887 2.90508 33.8887 6.02926C33.8887 6.9653 33.8883 9.40983 33.8878 12.5331H42.6632C44.4092 12.5331 46.4657 13.28 46.4657 15.4032C46.4657 16.5418 45.8596 17.8315 43.6745 18.2494V18.2979C44.9501 18.2979 47.1624 19.0447 47.1624 21.2973C47.1624 23.6226 44.7725 24.2684 43.4928 24.2684L33.8855 24.278C33.8841 30.8831 33.8828 36.7055 33.8828 36.7055C33.8828 36.7055 40.8081 36.7055 43.1143 36.7055C45.6335 36.7055 48.9125 34.3516 48.9125 30.7721C48.9125 24.7651 48.9125 0.119385 48.9125 0.119385C48.9125 0.119385 42.1544 0.119481 39.799 0.119481Z",
    fill: "url(#paint4_linear_3928_11528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3928_11528",
    x1: 0.0874023,
    y1: 18.413,
    x2: 15.117,
    y2: 18.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B327B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3928_11528",
    x1: 17.0244,
    y1: 18.4125,
    x2: 32.054,
    y2: 18.4125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#872D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3928_11528",
    x1: 36.838,
    y1: 20.7764,
    x2: 42.0396,
    y2: 20.7764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3928_11528",
    x1: 36.8198,
    y1: 15.8628,
    x2: 41.6006,
    y2: 15.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3928_11528",
    x1: 33.8827,
    y1: 18.4126,
    x2: 48.9123,
    y2: 18.4126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BB36"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbLogo);
export default __webpack_public_path__ + "static/media/jcbLogo.7e1e112948a7d8d5e6aba60de5e23f40.svg";
export { ForwardRef as ReactComponent };